import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import ServicesPage from "@/pages/ServicesPage";
import PhotosPage from "@/pages/PhotosPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";

function App() {
    return (
        <div className="App min-h-screen bg-brand-bg text-white font-body antialiased">
            <BrowserRouter>
                <Navbar />
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/services" element={<ServicesPage />} />
                    <Route path="/photos" element={<PhotosPage />} />
                    <Route path="/about" element={<AboutPage />} />
                    <Route path="/contact" element={<ContactPage />} />
                    <Route path="*" element={<HomePage />} />
                </Routes>
                <Footer />
                <Toaster
                    theme="dark"
                    position="bottom-right"
                    toastOptions={{
                        style: {
                            background: "#0A101D",
                            border: "1px solid rgba(255,255,255,0.1)",
                            color: "#fff",
                            fontFamily: "'IBM Plex Sans', system-ui, sans-serif",
                            borderRadius: 0,
                        },
                    }}
                />
            </BrowserRouter>
        </div>
    );
}

export default App;
